import React from "react"
import style from "../components/landing.module.scss"

export default function Landing({ tekst, row }) {

  return (
    <div className={style.wrapper} id = "landing" style={{ gridRow: row }}>
      <svg id="Laag_1" data-name="Laag 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 900" style= {{zIndex: '-1'}}>
        <path className="offsetWeefsel" style={{}} d="M0,605.92a1459.33,1459.33,0,0,0,160.66,74.17c97.73,38.13,217.32,83.58,373.69,85.58,82.1,1,151.06,1.92,228.2-34.23,48.3-22.64,60.76-41.49,128.37-71.32a685.33,685.33,0,0,1,162.6-48.49c99.45-16.67,178.35-7.24,208.23-2.85,81.78,12,140.28,36.58,202.54,62.75,92.74,39,82,48.2,165.44,79.87,86.47,32.84,163.65,47.88,196.83,54.2,37.49,7.15,69.52,11.51,93.44,14.26"/>
      </svg>
      <h1 mode="single" className={style.welkomstekst}>
        Zeven kunstenaars<br></br>onderzoeken en verbeelden<br></br>de
        textielverhalen<br></br>van Amersfoort
      </h1>
      <svg id="Laag_1" data-name="Laag 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 900">
        <text className={style.letter} fill = 'white' transform="matrix(0.94, 0.33, -0.33, 0.94, 1355.36, 610.47)">W</text>
        <text className={style.letter} fill = 'white' transform="matrix(0.93, 0.37, -0.37, 0.93, 1407.35, 629.09)">E</text>
        <text className={style.letter} fill = 'white' transform="matrix(0.92, 0.39, -0.39, 0.92, 1442.64, 643.43)">E</text>
        <text className={style.letter} fill = 'white' transform="translate(1477.61 658.03) rotate(24.73)">F</text>
        <text className={style.letter} fill = 'white' transform="translate(1508.96 672.64) rotate(27.01)"></text>
        <text className={style.letter} fill = 'white' transform="translate(1523.29 679.55) rotate(29.93)">m</text>
        <text className={style.letter} fill = 'white' transform="translate(1571.42 707.25) rotate(25.16)">e</text>
        <text className={style.letter} fill = 'white' transform="translate(1603.62 722.18) rotate(21.52)">e</text>
      </svg>
    </div>
  )
}
